import { render, staticRenderFns } from "./modalEditarPregunta.vue?vue&type=template&id=2681feae&scoped=true"
import script from "./modalEditarPregunta.vue?vue&type=script&lang=js"
export * from "./modalEditarPregunta.vue?vue&type=script&lang=js"
import style0 from "./modalEditarPregunta.vue?vue&type=style&index=0&id=2681feae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2681feae",
  null
  
)

export default component.exports